import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { useIntentContext } from '../../contexts/Intent/hooks/useIntentContext.js';
import { useDirectionContext } from '../../contexts/session/Locale.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { mapProps } from './BoxExperimentalCss.mappers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Box is a customizable styled div container that is capable of applying CSS styles while complying with Design Language.
 */
var Box = /*#__PURE__*/React.forwardRef(function (initialProps, ref) {
  var direction = useDirectionContext();
  var theme = useThemeContext();
  var _useIntentContext = useIntentContext(),
    intent = _useIntentContext.intent;
  var _mapProps = mapProps(initialProps, direction, theme, undefined, intent),
    as = _mapProps.as,
    attributes = _mapProps.attributes,
    children = _mapProps.children,
    className = _mapProps.className,
    style = _mapProps.style;
  return /*#__PURE__*/React.createElement(as !== null && as !== void 0 ? as : 'div', _objectSpread(_objectSpread({}, attributes), {}, {
    className: className,
    ref: ref,
    style: style
  }), children);
});
Box.displayName = 'Box';
Box.defaultProps = {};

export { Box as BoxExperimentalCss };
//# sourceMappingURL=BoxExperimentalCss.js.map
